import { render, staticRenderFns } from "./SlaTopReasons.vue?vue&type=template&id=688e4768&scoped=true&"
import script from "./SlaTopReasons.vue?vue&type=script&lang=js&"
export * from "./SlaTopReasons.vue?vue&type=script&lang=js&"
import style0 from "./SlaTopReasons.vue?vue&type=style&index=0&id=688e4768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e4768",
  null
  
)

export default component.exports